import {BrowserRouter as Router} from 'react-router-dom'
import { GlobalStateProvider } from './utils/GlobalContext'
import Nav from '@ui/Nav'
import Routes from '@ui/Routes'
import Loader from '@components/loader/Loader'
import { CardsContextProvider } from '@utils/CardsContext'
import { ChatProvider } from '@utils/ChatContext'
import ChatBot from '@components/chatbot/ChatBot'

function App() {
  return (
    <>  

        <Router>
          <GlobalStateProvider>
            <ChatProvider>
            <CardsContextProvider>
            <Nav/>
            <Routes/>
            <Loader/>
            <ChatBot/>
            </CardsContextProvider>
            </ChatProvider>
          </GlobalStateProvider>
        </Router>

    </>
  )
}
export default App
